import { useUser } from 'hooks/UseUser'

export const useCurrentUserIsManaged = () => {
  const user = useUser()

  return Boolean(user.managed_by_sso)
}
